import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { SmsStatusBadge } from "./SmsStatusBadge";

export default function SmsTestCard({ live, onSent }) {
  const [to, setTo] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    if (!to.trim()) return toast.error("Enter a mobile number");
    setSending(true);
    try {
      const { data } = await api.post("/sms/test", { to, body });
      setResult(data);
      if (data.status === "failed" || data.status === "skipped") toast.error(data.error || "Test SMS failed");
      else toast.success(data.status === "test_mode" ? "Logged in test mode (not sent)" : "Test SMS sent");
      onSent();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="border border-border/60 bg-card p-4 sm:p-8 rounded-sm" data-testid="sms-test-card">
      <div className="label-caps text-muted-foreground mb-2">Send a test SMS</div>
      <p className="text-sm text-muted-foreground mb-6">
        {live ? "Live mode is on — this sends a real text." : "Test mode — the message is logged but not sent."}
      </p>
      <div className="space-y-2">
        <Label className="label-caps text-muted-foreground">Australian mobile</Label>
        <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="+61412345678" data-testid="sms-test-to" />
      </div>
      <div className="space-y-2 mt-5">
        <Label className="label-caps text-muted-foreground">Message (optional)</Label>
        <Textarea value={body} onChange={(e) => setBody(e.target.value)} rows={3} data-testid="sms-test-body"
          placeholder="Leave blank to send your reminder template with the next booking's details" />
      </div>
      <Button onClick={send} disabled={sending} data-testid="sms-test-send" className="rounded-sm mt-6 gap-2">
        <Send className="w-4 h-4" /> {sending ? "Sending…" : "Send test"}
      </Button>
      {result && (
        <div className="mt-6 text-sm border-t border-border/60 pt-4 space-y-2" data-testid="sms-test-result">
          <div className="flex items-center gap-2">To {result.to} <SmsStatusBadge status={result.status} /></div>
          {result.error && <div className="text-xs text-muted-foreground">{result.error}</div>}
        </div>
      )}
    </section>
  );
}
